<template>
  <div id="roleAssignment">
    <Layout>
      <Sider style="background: #fff;margin-right: 10px;max-height:600px;overflow:auto" :width="250">
        <Card>
          <div slot="title">组织结构</div>
          <org-list :organizationList="organizationList" @selectNode="selectOrg"></org-list>
        </Card>
      </Sider>
      <Layout>
        <content>
          <Card style="position:relative">
            <Table border ref="orgMember" :columns="memberColumns" :data="orgUsersList" @on-selection-change="selectMember"></Table>
            <Button type="primary" style="margin-top: 20px;margin-right: 10px;" @click="batchMemberRole">批量添加角色</Button>
            <Button type="error" style="margin-top: 20px;margin-right: 10px;" @click="batchRemoveMemberRole">批量删除角色</Button>
            <Button type="primary" style="margin-top: 20px;margin-right: 10px;" @click="batchMemberArea">批量添加地区</Button>
            <Button type="error" style="margin-top: 20px;" @click="batchRemoveMemberRole">批量删除地区</Button>
            <Spin size="large" fix v-if="memberSpinShow"></Spin>
          </Card>
        </content>
      </Layout>
    </Layout>
    <edit-member-role :visible="memberRoleVisible" :roles="roles" @input="endMemberRoleInput" :editInfo="editInfo" @finish="finishEdit"></edit-member-role>
    <Modal v-model="memberAreaVisible" title="添加地区">
      <span>输入地区加英语逗号分隔</span>
      <Input v-model="addMemberAreas"></Input>
      <div slot="footer">
        <Button @click="memberAreaVisible=false">取消</Button>
        <Button type="primary" @click="confirmMemberArea">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import orgList from '../../../components/orgList'
import ajax from '../../../lib/userAjax'
import editMemberRole from './edit-member-role'
import requestUrls from '@/lib/requestUrls'

export default {
  name: 'roleAssignment',
  data() {
    return {
      organizationList: [],
      orgUsersList: [],
      memberColumns: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '姓名',
          key: 'name',
          width: 150
        },
        {
          title: '邮箱',
          key: 'emailAddress'
        },
        {
          title: '操作',
          key: 'action',
          width: 180,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.editRole(params)
                  }
                }
              }, '角色修改'),
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.editArea(params.row)
                  }
                }
              }, '地区修改')
            ])
          }
        }
      ],
      memberSpinShow: false,
      memberRoleVisible: false,
      roles: [],
      editInfo: {},
      selectMembers: [],
      selectOrgData: {},
      addMemberAreas: '',
      memberAreaVisible: false,
      isBatch: false
    }
  },
  created() {
    this.refreshOrganizationList()
    this.getRoles()
  },
  methods: {
    // 获取所有角色信息
    async getRoles() {
      let rep = await ajax.get('/api/services/app/User/GetRoles')
      if (rep.data.success) {
        this.roles = rep.data.result.items
      }
    },
    // 获取组织结构
    async refreshOrganizationList() {
      let rep = await ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnits');
      // 拷贝一个数组
      let copyOrgList = []
      const itemList = rep.data.result.items
      itemList.forEach(item => {
        copyOrgList.push({
          title: `${item.displayName}(${item.memberCount})`,
          id: item.id,
          parentId: item.parentId
        })
      })
      // 子组织归并
      for (let i = itemList.length - 1; i >= 0; i--) {
        let item = itemList[i]
        if (item.parentId) {
          for (let j = 0; j < copyOrgList.length; j++) {
            if (copyOrgList[j].id === item.parentId) {
              copyOrgList[j].expand = true
              copyOrgList[j].children = copyOrgList[j].children || []
              copyOrgList[j].children.push(copyOrgList.splice(i, 1)[0])
              break
            }
          }
        }
      }
      this.organizationList = copyOrgList
    },
    selectOrg(node) {
      this.selectOrgData = node
      this.chooseOrgItem(node)
    },
    // 获取组织用户
    async chooseOrgItem(data) {
      this.memberSpinShow = true
      let addUserOrgId = data.id
      let params = {
        Id: addUserOrgId,
        MaxResultCount: 1000, // 每页数量，获取全部人数（人员不多情况）
        SkipCount: 0 // 开始条数
      }
      let rep = await ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitUsers', { params: params })
      if (rep.data.success) {
        this.orgUsersList = rep.data.result.items
      }
      this.memberSpinShow = false
    },
    editRole(params) {
      this.editInfo = {
        type: 'single',
        editMember: [params.row]
      }
      this.memberRoleVisible = true
    },
    editArea(member) {
      this.selectMembers = [member]
      this.addMemberAreas = member.selectDistrict
      this.isBatch = false
      this.memberAreaVisible = true
    },
    endMemberRoleInput() {
      this.memberRoleVisible = false
    },
    batchMemberRole() {
      this.editInfo = {
        type: 'batch',
        editMember: this.selectMembers
      }
      this.memberRoleVisible = true
    },
    batchMemberArea() {
      this.addMemberAreas = ''
      this.isBatch = true
      this.memberAreaVisible = true
    },
    batchRemoveMemberRole() {
      this.editInfo = {
        type: 'batchRemove',
        editMember: this.selectMembers
      }
      this.memberRoleVisible = true
    },
    selectMember(val) {
      this.selectMembers = val
    },
    finishEdit() {
      this.memberRoleVisible = false
      this.chooseOrgItem(this.selectOrgData)
    },
    async confirmMemberArea() {
      let result = []
      let areas = this.addMemberAreas.split(',')
      this.selectMembers.forEach(member => {
        let districts = []
        if (this.isBatch && member.selectDistrict) {
          districts = member.selectDistrict.split(',')
        }
        let memberObj = {
          userId: member.id,
          districts: districts
        }
        areas.forEach(area => {
          if (memberObj.districts.indexOf(area) === -1 && area) {
            memberObj.districts.push(area)
          }
        })
        result.push(memberObj)
      })
      this.$Spin.show()
      let rep = await ajax.post(requestUrls.User.BatchUpdateDistrict, result)
      this.$Spin.hide()
      if (rep.data.success) {
        this.$Message.success('添加地区成功')
      } else {
        this.$Message.error('添加地区失败')
      }
    }
  },
  components: {
    orgList,
    editMemberRole
  }
}
</script>

<style lang="less" scoped>
</style>
